import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-163161f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gridEncontrar" }
const _hoisted_2 = { class: "form-floating mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "buscar" }, "Buscar por ID:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Filtrar por Estatus", -1))
const _hoisted_5 = { class: "gridposts" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            id: "search",
            type: "buscar",
            placeholder: "Buscar",
            class: "form-control",
            autofocus: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.term) = $event)),
            onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => ($props.search($data.term)), ["enter"]))
          }, null, 544), [
            [_vModelText, $data.term]
          ]),
          _hoisted_3
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.filters, (filter) => {
          return (_openBlock(), _createElementBlock("p", {
            class: _normalizeClass([$options.toColor(filter), "post"]),
            style: {"cursor":"pointer"},
            key: filter,
            onClick: () => $props.filterEspecialistas(filter)
          }, _toDisplayString(filter), 11, _hoisted_6))
        }), 128))
      ])
    ])
  ], 64))
}